<script lang="ts">
  import {onMount} from 'svelte'
  import {_} from 'svelte-i18n'
  import {getFixedNews, initNewsline} from './services/index'
  import {searchPublications} from '../../custom/GlobalSearch/services/index.js'
  import {fixedNews, selectedGroup} from "./store"
  import {
    countByGroup,
    globalSearch, info_client,
    isDirtySearch,
    isShowSearchLoader,
    list,
  } from './../../stores'

  import NewslineAllViewModal from './components/NewslineAllViewModal/NewslineAllViewModal.svelte';
  import NewslineFixedPreviewCards from './components/NewslineFixedPreviewCards/NewslineFixedPreviewCards.svelte'
  import NewslineSearchDivider from './components/NewslineSearch/components/NewslineSearchDivider.svelte'
  import NewslineInfiniteScroll from './components/NewslineInfiniteScroll/NewslineInfiniteScroll.svelte'
  import NewslineCuratorFilters from './components/NewslineCuratorFilters/NewslineCuratorFilters.svelte'
  import NewslineNoItemsBanner from './components/NewslineNoItemsBanner/NewslineNoItemsBanner.svelte'
  import NewslinePreviewCards from './components/NewslinePreviewCards/NewslinePreviewCards.svelte'
  import NewslineLoader from './components/NewslineLoader/NewslineLoader.svelte'
  import NewslineTabs from './components/NewslineTabs/NewslineTabs.svelte'
  import GeneralLayout from '../../layouts/GeneralLayout.svelte'
  import GlobalSearch from "../../custom/GlobalSearch/GlobalSearch.svelte";
  import GlobalSearchInfo from "../../custom/GlobalSearch/GlobalSearchInfo.svelte";
  import GlobalSearchTags from "../../custom/GlobalSearch/GlobalSearchTags.svelte";

  let listPT = []
  let listRPP = []
  let listWiki = []
  let wikiByFolders = []
  let searchResults = []
  let isRPP = false

  $: listPT = $list.filter(el => !el.wiki_page && el.feed_group.slug !== 'physical_rpp')
  $: listRPP = $list.filter(el => !el.wiki_page && el.feed_group.slug === 'physical_rpp')
  $: listWiki = $list.filter(el => el.wiki_page)
  $: wikiByFolders = listWiki.reduce((acc, el) => {
    const title = el.wiki_page.title;
    if (!acc[title]) {
      acc[title] = [];
    }
    acc[title].push(el);
    return acc;
  }, {})

  $: isRPP = $selectedGroup?.slug === 'physical_rpp'
  $: searchResults = [
    {
      list: listPT,
      count: $countByGroup?.physical_transformation,
      order: isRPP ? 2 : 1,
      title: 'Physical Transformation'
    },
    $info_client.is_paid_rpp_current_flow &&
    {
      list: listRPP,
      count: $countByGroup?.rpp,
      order: isRPP ? 1 : 2,
      title: 'Physical Psychology'
    },
    {
      list: wikiByFolders,
      count: $countByGroup?.wiki,
      order: 3,
      title: $_('PhTWiki')
    },
  ]

  const search = async () => {
    fixedNews.set([])
    list.set([])

    await searchPublications({
      orderingGroup: isRPP ? 'rpp' : 'feed'
    })

    if (!$globalSearch.length) {
      await getFixedNews()
    }

    isShowSearchLoader.set(false)
  }

  onMount(initNewsline)
</script>

<GeneralLayout>
  <NewslineCuratorFilters/>
  <NewslineTabs/>
  <GlobalSearch on:search={search}/>
  <GlobalSearchTags on:search={search}/>

  {#if $isDirtySearch}
    <GlobalSearchInfo searchResults={searchResults}/>
  {:else}
    <NewslineFixedPreviewCards/>
    <NewslinePreviewCards/>
    <NewslineNoItemsBanner/>
  {/if}

  <NewslineLoader/>
  <NewslineSearchDivider/>
</GeneralLayout>

<NewslineInfiniteScroll/>
<NewslineAllViewModal/>